import React, { useEffect } from 'react';
import { useCamera } from '../../hooks/useCamera';
import { useGestureRecognition } from '../../hooks/useGestureRecognition';
import { useAppStore } from '../../store/appStore';

export const CameraFeed: React.FC = () => {
  const { videoRef, isActive, error, startCamera, stopCamera } = useCamera();
  const { setCameraActive } = useAppStore();
  const { isInitialized } = useGestureRecognition(videoRef.current);

  useEffect(() => {
    setCameraActive(isActive);
  }, [isActive, setCameraActive]);

  return (
    <div className="camera-container">
      <div className="video-wrapper">
        <video
          ref={videoRef}
          autoPlay
          playsInline
          muted
          className="camera-video"
        />
        {!isActive && (
          <div className="camera-overlay">
            <p>Camera is off</p>
          </div>
        )}
      </div>

      <div className="camera-controls">
        {!isActive ? (
          <button onClick={startCamera} className="btn btn-primary">
            Start Camera
          </button>
        ) : (
          <button onClick={stopCamera} className="btn btn-secondary">
            Stop Camera
          </button>
        )}
      </div>

      {error && (
        <div className="error-message">
          {error}
        </div>
      )}

      {isActive && !isInitialized && (
        <div className="loading-message">
          Initializing AI models...
        </div>
      )}

      {isActive && isInitialized && (
        <div className="status-message success">
          Ready to recognize gestures
        </div>
      )}
    </div>
  );
};
